export default __webpack_public_path__ + "static/media/CloudOverview.136a8c1f.jpg";